module.exports = __webpack_public_path__ + "img/meinmed.97c7570d.svg";